import IS_CLIENT_RENDERED from "./isClientRendered";

let _window;

if (!IS_CLIENT_RENDERED) {
  _window = {
    location: {
      href: "",
      origin: "",
      reload: () => null,
    },
  };
} else {
  _window = window;
}

export const goToUrl = url => {
  _window.location.href = url;
};

export const currentWindowUrl = () => {
  return _window.location.href;
};

export const currentWindowOrigin = () => {
  return _window.location.origin;
};

export const reload = () => {
  _window.location.reload();
};



// WEBPACK FOOTER //
// ./src/util/windowLocation.js